import React, { useState, useEffect, Component } from "react";
import ReactDOM from "react-dom";
import MaterialTable from "@material-table/core";
import Footer from "../../../components/shared/Footer";
import { Button } from "react-bootstrap";
import { PendingServiceDocument } from "../../../models";
import { PendingServiceService } from "../../../services/SubmissionService";
import IgnoreModal from "./components/IgnoreModal";
import { IgnoreService } from "../../../models/swagger/generated-submission-service";

export default function PendingServices() {
    const never = "never" as const;

    const [data, setData] = useState([] as PendingServiceDocument[]);
    const [ignoreModalId, setIgnoreModalId] = useState("");

    useEffect(() => {
        PendingServiceService.getList({}).then(
            (resp) => {
                if (resp.successful && resp.data) {
                    setData(resp.data);
                } else {
                    //TODO: Show error
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    const refreshData = () => {
        PendingServiceService.getList({}).then(
            (resp) => {
                if (resp.successful && resp.data) {
                    setData(resp.data);
                } else {
                    //TODO: Show error
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const onIgnore = (id: string, notify: boolean, reason: string) => {
        if (notify == true) {
            PendingServiceService.notify({
                id,
                body: { submissionID: id, notes: reason },
            }).then((res) => {
                refreshData();
            });
        } else {
            PendingServiceService.ignore({
                id,
                body: { submissionID: id, notes: reason },
            }).then((res) => {
                refreshData();
            });
        }
        setIgnoreModalId("");
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Process Service</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Documents Pending Service
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <IgnoreModal
                    id={ignoreModalId}
                    show={ignoreModalId != ""}
                    onConfirm={onIgnore}
                    onCancel={() => setIgnoreModalId("")}
                />
                <div className="row m-2">
                    <div
                        className="col-sm-8"
                        style={{ maxWidth: "100%", zIndex: 50 }}
                    ></div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%", zIndex: 20 }}>
                            <MaterialTable
                                options={{
                                    pageSizeOptions: [5, 10, 20, 50, 75, 100],
                                }}
                                columns={[
                                    {
                                        title: "ID",
                                        field: "id",
                                        editable: never,
                                    },
                                    {
                                        title: "Attorney Name",
                                        field: "attorneyName",
                                    },
                                    {
                                        title: "Case Number",
                                        field: "ucn",
                                    },
                                    {
                                        title: "Filed Date",
                                        field: "filedDateTime",
                                    },
                                    {
                                        title: "Missing Documnets",
                                        field: "missingDocuments",
                                    },
                                ]}
                                data={data}
                                title="Pending Service Documents"
                                actions={[
                                    {
                                        icon: "delete",
                                        tooltip: "Ignore Suit",
                                        onClick: (event, rowData) => {
                                            setIgnoreModalId(
                                                (
                                                    rowData as PendingServiceDocument
                                                ).id ?? ""
                                            );
                                        },
                                        //(window.location.href = `/admin/attorneys/edit/Id=${rowData}`),
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
